import { Controller } from "@hotwired/stimulus"

const ENTER_FROM = ["opacity-0", "translate-y-2", "sm:translate-y-0", "sm:translate-x-2"]
const ENTER_TO = ["opacity-100", "translate-y-0", "sm:translate-x-0"]
const EXIT_MS = 300

// Connects to data-controller="toast". Renders transient notifications fired via
// window.toast(message, { kind }) (see controllers/application.js), which dispatches
// the toast:show event this controller listens for. kind is "notice" (default) or "alert".
export default class extends Controller {
    static targets = ["container", "template"]
    static values = { duration: { type: Number, default: 4000 } }

    receive({ detail: { message, kind } = {} }) {
        if (message) this.#render(message, kind)
    }

    dismiss(event) {
        this.#dismiss(event.currentTarget.closest("[data-toast]"))
    }

    #render(message, kind = "notice") {
        const isError = kind === "alert" || kind === "error"
        const toast = this.templateTarget.content.firstElementChild.cloneNode(true)
        toast.querySelector("[data-toast-message]").textContent = message
        toast.querySelector(`[data-toast-icon="${isError ? "notice" : "alert"}"]`).remove()

        this.containerTarget.appendChild(toast)
        requestAnimationFrame(() => {
            toast.classList.remove(...ENTER_FROM)
            toast.classList.add(...ENTER_TO)
        })
        setTimeout(() => this.#dismiss(toast), this.durationValue)
    }

    #dismiss(toast) {
        if (!toast || toast.dataset.dismissed === "true") return
        toast.dataset.dismissed = "true"
        toast.classList.remove(...ENTER_TO)
        toast.classList.add(...ENTER_FROM)
        setTimeout(() => toast.remove(), EXIT_MS)
    }
}
